import { PERMISSIONS } from '../usersPermissions/usersPermissionsAuthorizationsCIBio';

export const isAdmin = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.Admin);

    return isRole.length ? true : false;
}